import React from "react";
import { Modal } from "react-bootstrap";

const PromoCodeViewEmailModal = ({
  viewEmailDataModal,
  handleCloseViewEmailDataModal,
  allUsers,
  editEmailData,
  setEditEmailData,
  updateUserGroup
}) => {
  return (
    <div>
      <Modal
        show={viewEmailDataModal}
        onHide={handleCloseViewEmailDataModal}
        backdrop="static"
        className="edit-group-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Group Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-2 col-sm-12">
            <div className="form-group">
              <label for="userList">Select Users</label>
              <select
                name=""
                id=""
                className="form-control"
                onChange={(e) => {
                  const selectedValue = e?.target?.value;
                  const selectedItem = allUsers?.find(
                    (item) => item?.Id === selectedValue
                  );
                  setEditEmailData([...editEmailData, selectedItem?.Email]);
                  e.target.value = "";
                }}
              >
                <option value="">Select Email</option>
                {allUsers?.map((item) => {
                  return (
                    <option value={item?.Id}>
                      {item?.Email ? item?.Email : null}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="table-responsive custom-table-01">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {editEmailData?.map((item, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item}</td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => {
                            const filter = editEmailData?.filter(
                              (i) => i !== item
                            );
                            setEditEmailData(filter);
                          }}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="col-lg-12">
            <button type="button" className="btn btn-primary common_btn_pd" onClick={()=>updateUserGroup("editEmail")}>
              Update User Group
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default PromoCodeViewEmailModal;
